<button class="mtn-icon-button" [ngClass]="{'mini': isMini}" mat-raised-button [color]="color" (click)="doClick($event)"
        [disabled]="disabled" fxLayoutAlign="center center">
  <ng-content></ng-content>
</button>
